import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { formatDurationLong } from '@/formatters/formatDurationLong';

interface RecordingTimerProps {
  readonly elapsedSeconds: number;
}

export const RecordingTimer = ({ elapsedSeconds }: RecordingTimerProps) => (
  <Text style={styles.timer}>{formatDurationLong(elapsedSeconds * 1000)}</Text>
);

const styles = StyleSheet.create({
  timer: {
    fontSize: 41,
    lineHeight: 48,
    textAlign: 'center',
    color: '#000000',
    fontVariant: ['tabular-nums'],
  },
});
